// extracted by mini-css-extract-plugin
export default {"button":"MainPageButton_button__dfkqG","text":"MainPageButton_text__qgX7+","leftIcon":"MainPageButton_leftIcon__teWs-","rightIcon":"MainPageButton_rightIcon__JJ9mT"};